import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03ae20a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", {
    for: "unlinked",
    class: "-mr-2 -ml-2 mb-2"
  }, "LINEアカウントの紐付け")
], -1))
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "formgrid formgroup-inline grid w-full" }
const _hoisted_4 = { class: "block vertical-align-bottom hg-36 lbl-text mr-3" }

import { withDefaults } from "vue";
import Button from "primevue/button";

type IProps = {
  id: number;
  disabled: boolean;
};

enum LabelNameEnum {
  true = "紐付け済み",
  false = "紐付けなし",
}


export default /*#__PURE__*/_defineComponent({
  __name: 'unlinked',
  props: {
    id: { default: 0 },
    disabled: { type: Boolean, default: false }
  },
  emits: ["unlinked"],
  setup(__props: any, { emit: emits }) {

const props = __props as { id: number, disabled: boolean };





const onUnlinked = () => emits("unlinked", props.id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(LabelNameEnum[!__props.disabled as unknown as string]), 1),
        _createVNode(_unref(Button), {
          class: "btn-unlinked hg-36 w-10rem text-center justify-content-center",
          icon: "icon-lms icon-lms_detach",
          label: "紐付け解除",
          onClick: onUnlinked,
          disabled: props.disabled
        }, null, 8, ["disabled"])
      ])
    ])
  ], 64))
}
}

})